module.exports = new __parcel__URL__("backlog-preview.286ce430.svg").toString();